import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import HouseHold from "../views/HouseHold.vue";
import About from "../views/About.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "nv1500",
      metaTags: [
        {
          name: "description",
          content: "Numero Verde 1500",
        },
        {
          property: "og:description",
          content: "Numero Verde 1500",
        },
      ],
    },
  },
  {
    path: "/start",
    name: "Start",
    component: () => import(/* webpackChunkName: "start" */ "../views/Start"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import(/* webpackChunkName: "start" */ "../views/Privacy"),
  },

  {
    path: "/casa",
    name: "Casa",
    component: HouseHold,
    children: [
      {
        path: ":id",
        name: "CasaMia",
        component: HouseHold,
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/logout",
    name: "Logout",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Logout.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
